@if (items?.length) {
  <div class="m-t-2"
    >
    @for (attribute of items; track trackByItem($index, attribute); let isFirst = $first) {
      <div class="flex c1"
        >
        @if (!(attribute.isText && attribute.isTextArea)) {
          <div>{{ attribute.label }}:&nbsp;</div>
        }
        <div class="col-11">{{ attribute.valuesLabels.join(', ') }}</div>
      </div>
    }
  </div>
}
